/**
 * @module vuex/getters
 */
export default {
    /**
     * Get the state for temporary data what you had store
     * @param state - from vuex/state
     * @example let state = store.getters.temporaryData
     */
    temporaryData: (state) => { return state.temporaryData },
    allChartData: (state) => { return state.allChartData },
    //
    access_token:(state) => {return state.access_token},
    userId:(state) => {return state.user.userId},
    access_phone:(state) => {return state.access_phone},
    user:(state) => {
        return state.user?state.user:JSON.parse(localStorage.getItem('user'))
    },
}